<template>
    <div id="app">
        <router-view />

        <el-dialog :title="dlgData.title" :visible.sync="dlgData.visible" :close-on-click-modal="false" :append-to-body="true" width="500px" center>
            <div v-html="dlgData.content"></div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click.native.prevent="() => {dlgData.visible = false;}">好的，我已了解</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script :src="require('@/static/ckeditor/ckeditor.js')"></script>
<script>
import { mapGetters } from "vuex";
export default {
    name: 'App',
    data() {
        return {
            dlgData: {
                title: '通知',
                content: '',
                visible: false
            }
        }
    },
    computed: {
        ...mapGetters({
            siteInfo: "siteInfo"
        })
    },
    watch: {
        siteInfo(newVal) {
            if (newVal) {
                document.title = this.siteInfo.SITE_NAME;
                document.querySelector("meta[name=description]").setAttribute("content", newVal.seoDesc);
                document.querySelector("meta[name=keywords]").setAttribute("content", newVal.seoKeyword);
                this.changeFavicon(this.Utils.getResourceUrl(newVal.browserIcon));
                this.changeSeo(newVal.seoDesc, newVal.seoKeyword)
                this.showPopDlg();
            }
        }
    },
    mounted() {
        let theme = this.$store.getters.theme || localStorage.getItem('theme');
        document.querySelector('body').className = theme;
        document.querySelector('title')
        this.initWebSiteStatsticPlugin();
    },
    methods: {
        changeFavicon(src) {
            var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = src;
            document.getElementsByTagName('head')[0].appendChild(link);
        },
        changeSeo(description, keyword) {
            var metaDesc = document.querySelector("meta[name='description']") || document.createElement('meta');
            metaDesc.name = 'description';
            metaDesc.content = description;
            document.getElementsByTagName('head')[0].appendChild(metaDesc);

            var metaKeyword = document.querySelector("meta[name='keywords']") || document.createElement('meta');
            metaKeyword.name = 'keywords';
            metaKeyword.content = keyword;
            document.getElementsByTagName('head')[0].appendChild(metaKeyword);
        },
        showPopDlg() {
            if (this.siteInfo && this.siteInfo.settings && this.siteInfo.settings['SHOW_POP_DLG_AFTER_ENTERING'] && this.siteInfo.settings['SHOW_POP_DLG_AFTER_ENTERING'] == 'true') {
                if (this.siteInfo.settings['POP_DLG_CONTENT'] && this.siteInfo.settings['POP_DLG_CONTENT'].length > 0) {
                    // 显示弹窗
                    try {
                        let json = JSON.parse(this.siteInfo.settings['POP_DLG_CONTENT']);
                        this.dlgData.content = json.content;
                        this.dlgData.title = json.title;
                        this.dlgData.visible = true;
                    } catch (err) {
                        this.dlgData.content = this.siteInfo.settings['POP_DLG_CONTENT'];
                        this.dlgData.visible = true;
                    }
                }
            }
        },
        // 初始化站点统计组件
        initWebSiteStatsticPlugin() {
            // 添加脚本
            if (this.siteInfo && this.siteInfo.staticCode && this.siteInfo.staticCode.length > 0) {
                let LA_COLLECT = document.getElementById("LA_COLLECT");
                if (!LA_COLLECT) {
                    const script = document.createElement('script');
                    script.id = 'LA_COLLECT';
                    script.charset = "UTF-8";
                    document.body.appendChild(script);
                    script.onload = () => {
                        eval(this.siteInfo.staticCode);
                    }
                }
            }
        }
    }
}
</script>
